import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { FunctionComponent, useEffect } from 'react';
import { apiLinks } from './links';
import { DIRECTUS_LS_CACHE_PREFIX, purgeExpiredDirectusCache } from './links/directusLocalStorageCache';

if (process.env.REACT_APP_BASE_API_URL === undefined) {
  throw new Error('API URL required');
}

const DEFAULT_CACHE_CLEANUP_MINUTES = 5;
const CACHE_CLEANUP_MINUTES = parseInt(process.env.REACT_APP_CACHE_CLEANUP_MINUTES ?? '', 10);
const CACHE_CLEANUP_MS =
  (isNaN(CACHE_CLEANUP_MINUTES) ? DEFAULT_CACHE_CLEANUP_MINUTES : CACHE_CLEANUP_MINUTES) * 60 * 1000;

const DIRECTUS_CACHE_BUSTER = String(process.env.REACT_APP_DIRECTUS_CACHE_BUSTER ?? '').trim();

export const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          tagsObject: {
            merge(_existing: unknown, incoming: unknown): unknown {
              return incoming;
            },
          },
        },
      },
      directus_files: {
        keyFields: false,
        merge: (existing: unknown, incoming: unknown): unknown => {
          return { ...(existing as Record<string, unknown>), ...(incoming as Record<string, unknown>) };
        },
      },
    },
  }),
  link: apiLinks,
  connectToDevTools: true,
  credentials: 'include',
});

interface Props {
  children: JSX.Element;
}

export const ManagedApolloProvider: FunctionComponent<Props> = ({ children }) => {
  useEffect(() => {
    purgeExpiredDirectusCache(DIRECTUS_LS_CACHE_PREFIX, DIRECTUS_CACHE_BUSTER);

    const id = window.setInterval(() => {
      purgeExpiredDirectusCache(DIRECTUS_LS_CACHE_PREFIX, DIRECTUS_CACHE_BUSTER);
    }, CACHE_CLEANUP_MS);

    return () => {
      window.clearInterval(id);
    };
  }, []);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
